import Router from "../router";
import Store from "../store";
import Parse from "../configs/parse";
import { addCommas } from "@persian-tools/persian-tools";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import jalaliday from "jalaliday";

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(jalaliday);

export default {
  /**
   * Returns a ist of all possible statuses of loads
   * @returns {*[]}
   */
  statusList() {
    return [
      {
        code: 1,
        class: "box-gray",
        text: "در انتظار بررسی ",
      },
      {
        code: 2,
        class: "box-yellow",
        text: "در انتظار پرداخت ",
      },
      {
        code: 3,
        class: "box-lightRed",
        text: "در انتظار تخصیص راننده (پرداخت شده)",
      },
      {
        code: 4,
        class: "box-red",
        text: "بار در حال حمل (پرداخت شده)",
      },
      {
        code: 5,
        class: "box-darkRed",
        text: "فرآیند حمل تکمیل شده (پرداخت شده)",
      },
      {
        code: 6,
        class: "box-green",
        text: "فرآیند حمل بار به اتمام رسیده است",
      },
      {
        code: 100,
        class: "box-lightPurple",
        text: "در انتظار تخصیص راننده (پس پرداخت)",
      },
      {
        code: 101,
        class: "box-purple",
        text: "بار در حال حمل (پس پرداخت)",
      },
      {
        code: 102,
        class: "box-darkPurple",
        text: "فرآیند حمل کامل شده، در انتظار پرداخت (پس پرداخت)",
      },
      {
        code: 103,
        class: "box-pink",
        text: "پرداخت انجام شده، درانتظار تخصیص هزینه ها",
      },
      {
        code: 104,
        class: "box-green",
        text: "فرآیند حمل بار به اتمام رسیده است",
      },
    ];
  },
  /**
   * Finds the status data based on the received code
   * @returns {*[]}
   */
  getStatusData(code) {
    return this.statusList().filter((item) => item.code == code)[0];
    //return list[0];
  },
  /**
   * Copies the text into the clipboard if the client browser supports this feature
   * @param text
   */
  fallbackCopyTextToClipboard(text) {
    let textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      let isCopied = document.execCommand("copy");
      if (isCopied) {
        Store.commit("show_snackbar", {
          text: "کپی شد",
          actionBtn: false,
        });
      }
    } catch (err) {
      console.error("Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
  },
  /**
   * Copies the text into the clipboard if the client browser supports this feature
   * @param text
   */
  copyText(text) {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text);
      return;
    }

    navigator.clipboard.writeText(text).then(
      () => {
        Store.commit("show_snackbar", {
          text: "کپی شد",
          actionBtn: false,
        });
      },
      function (err) {
        console.error("Oops, unable to copy", err);
      }
    );
  },
  /**
   * Convert date from Gregorian (Miladi) to Jalali
   *
   * @param date
   * @param time
   */
  getJDate(date, time = false) {
    return dayjs(date)
      .calendar("jalali")
      .format(time === true ? "YYYY/MM/DD HH:mm:ss" : "YYYY/MM/DD");
  },
  /**
   * Convert date from Miladi to Jalali
   * @param date
   * @param time
   */
  getJMonthDay(date) {
    let dt = dayjs(date, { jalali: true });
    let res = dt.locale("fa").format("D MMMM");
    return res;
  },
  /**
   * Convert date from Miladi to Jalali
   * @param date // miladi
   */
  getJDayOfWeek(date) {
    let dt = dayjs(date);
    let res = dt.day();

    let days = [
      "یکشنبه",
      "دوشنبه",
      "سه شنبه",
      "چهارشنبه",
      "پنج شنبه",
      "جمعه",
      "شنبه",
    ];

    return days[res];
  },
  /**
   * Calculating time diffrence based on current time
   *
   * @param date
   */
  getTimeDiff(date) {
    const now = dayjs();
    const givenDate = dayjs(date);

    const diffDuration = dayjs.duration(givenDate.diff(now));
    return diffDuration.locale("fa").humanize(true);
  },

  /**
   * Validation methods for Vuetify form fields
   */
  validators: {
    /**
     * This field is required and cant't be left empty
     * @param value
     * @returns {boolean|string}
     */
    required: (value) => !!value || "این فیلد الزامیست",
    /**
     * Only numbers are allowed
     * @param value
     * @returns {boolean|string}
     */
    onlyNumbers: (value) => {
      const pattern = /^(\d)*$/;
      if (!value || pattern.test(value)) {
        return true;
      } else {
        return "فقط عدد مجاز است";
      }
    },
    /**
     * Only Iran money format is allowed
     * @param value
     * @returns {boolean|string}
     */
    onlyMoney: (value) => {
      const pattern = /^[\d,]*$/;
      return pattern.test(value) || "فقط فرمت پول مجاز است";
    },
    /**
     * Hyphen is not allowed
     * @param variable
     * @param number
     * @returns {boolean|string}
     */
    noHyphen: (value) => value.trim() != "-" || "مقدار وارد شده معتبر نیست.",
    /**
     * Variable length must be less than number
     * @param variable
     * @param number
     * @returns {boolean|string}
     */
    maxChars(variable, number) {
      return (
        variable.length <= number || "حداکثر " + number + " کاراکتر مجاز است"
      );
    },
    /**
     * Variable length must be exactly same as length or null
     * @param variable
     * @param length
     * @returns {boolean|string}
     */
    fixedLength(variable, length) {
      return (
        (variable != null && variable.length == length) ||
        !variable ||
        "طول فیلد باید " + length + " کاراکتر باشد"
      );
    },
    /**
     * Variable must be between minLength and maxLength
     * @param variable
     * @param minLength
     * @param maxLength
     * @returns {boolean|string}
     */
    betweenLength(variable, minLength, maxLength) {
      return (
        (variable != null &&
          variable.length <= maxLength &&
          variable.length >= minLength) ||
        !variable ||
        `طول فیلد باید بین ${minLength} تا ${maxLength}  کاراکتر باشد. `
      );
    },
    /**
     * String must starts with chars
     * @param variable
     * @param chars
     * @returns {string|boolean}
     */
    startsWith(variable, chars) {
      if (variable && variable.length) {
        const pattern = new RegExp("^" + chars);
        if (pattern.test(variable)) {
          return true;
        } else {
          return "باید با " + chars + "شروع شود";
        }
      } else {
        return true;
      }
    },
    /**
     * Only iran mobile format is allowed
     * @param value
     * @returns {boolean | string}
     */
    iranmobile: (value) => {
      const pattern = /^09\d{9}$/;
      return pattern.test(value) || "مثال شماره موبایل صحیح: 09111111111";
    },
    /**
     * value must contains atleast one space
     * @param value
     * @param message
     * @returns {boolean | string}
     */
    oneSpace(value, message) {
      return (
        (value && value.split(" ").length > 1) || message || "حداقل 2 کلمه"
      );
    },
    notEmpty: (value) => {
      if (value && value.length) {
        return true;
      } else {
        return "فیلد نباید خالی باشد";
      }
      // return value.length > 0 ||  'فیلد نباید خالی باشد'
    },
  },
  /**
   * depricated
   * @returns {*[]}
   */
  errorCodes() {
    return [
      {
        code: 1003,
        message: "نام کاربری یا کلمه عبور صحیح نیست",
      },
      {
        code: 1004,
        message: "شماره وارد شده صحیح نیست",
      },
      {
        code: 2001,
        message: "اطلاعات پروفایل کامل نیست",
      },
      {
        code: 2002,
        message: "کاربر یافت نشد",
      },
      {
        code: 2003,
        message: "کاربر راننده نیست",
      },
      {
        code: 2004,
        message: "پارامترهای ارسالی ناقصند",
      },
      {
        code: 2005,
        message: "بار یافت نشد",
      },
      {
        code: 3000,
        message: "عدم دسترسی",
      },
      {
        code: 4000,
        message: "",
      },
    ];
    /*
        0- 1003 invalid username or password
        1- 1004 invalid phone number
        2- 2001 complete user info
        3- 2002 user not found*
        4- 2003 user type not equal driver
        5- 2004 incomplete params
        6- 2005 load not found
        7- 3000 access deniad
        8- 4000 isArrived driver is false
        9- 4004 user already exists
        */
  },
  calcDifferenceDays(firstDate, secondDate) {
    // calc number of difference days beetwin two days
    return Math.round(
      (firstDate.getTime() - secondDate.getTime()) / (1000 * 60 * 60 * 24)
    );
  },
  formatCreatedAt(ISOCreatedAt) {
    const now = new Date();
    const createdAt = new Date(ISOCreatedAt);
    const differenceFromNow = this.calcDifferenceDays(now, createdAt);
    const JalaliDate = this.getJDate(ISOCreatedAt);
    let result = JalaliDate;

    if (differenceFromNow === 0) {
      result = "امروز";
    } else if (differenceFromNow === 1) {
      result = "دیروز";
    } else if (differenceFromNow > 1 && differenceFromNow < 7) {
      result = `${differenceFromNow} روز پیش`;
    } else if (differenceFromNow >= 7 && differenceFromNow < 14) {
      result = "یک هفته پیش";
    } else if (differenceFromNow >= 14 && differenceFromNow < 21) {
      result = "دو هفته پیش";
    } else if (differenceFromNow >= 21 && differenceFromNow <= 35) {
      result = "یک ماه گذشته";
    }
    return result;
  },
  doesContainPhone(text) {
    const mobileReg =
        /(0|\+98)?([ ]|-|[()]){0,2}9[0|1|2|3|4|5|6|7|8|9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/gi,
      junkReg = /[^\d]/gi,
      persianNum = [
        /۰/gi,
        /۱/gi,
        /۲/gi,
        /۳/gi,
        /۴/gi,
        /۵/gi,
        /۶/gi,
        /۷/gi,
        /۸/gi,
        /۹/gi,
      ],
      numToEn = function (str) {
        for (let i = 0; i < 10; i++) {
          str = str.replace(persianNum[i], i);
        }

        return str;
      },
      getMobiles = function (str) {
        const mobiles = numToEn(str + "").match(mobileReg) || [];

        mobiles.forEach(function (value, index, arr) {
          arr[index] = value.replace(junkReg, "");
          arr[index][0] === "0" || (arr[index] = "0" + arr[index]);
        });

        return mobiles;
      };

    return getMobiles(text);
  },
  goToLoginProject() {
    const loginAppUrl = `${process.env.VUE_APP_LOGIN_URL}?redirect=${window.location.origin}`;
    window.open(loginAppUrl, "_parent", "noopener noreferrer");
  },
  /**
   * Handles most of the known error messages in the app
   *
   * @param message - error message that you have received
   * @param changed array - list of items that you want to merge into defaults
   * @param logOut bool - Logout the user after showing message ?
   * @param showMessage bool - Shows the message if true
   * @param onlyThese array - check only these error codes, don't check this with dontCheck
   * @param dontCheck array - don't check these error codes, don't check this with onlyThese
   * @return mixed
   */
  handleErrorIfKnown(
    message,
    { changed = null, showMessage = true, onlyThese = [], dontCheck = [] } = {}
  ) {
    let defaultMessages = [
      {
        code: "Unable to connect to the Parse API",
        message:
          "قادر به برقراری ارتباط با سرور نیستیم. لطفا اتصال اینترنت خود را بررسی نمایید.",
        options: null,
      },
      {
        code: 'XMLHttpRequest failed: "Unable to connect to the Parse API"',
        message:
          "قادر به برقراری ارتباط با سرور نیستیم. لطفا اتصال اینترنت خود را بررسی نمایید.",
        options: null,
      },
      {
        code: "invalid session token",
        message: "لطفا مجددا وارد شوید",
        callback: () => this.softLogOut(),
      },
      {
        code: "Invalid session token",
        message: "لطفا مجددا وارد شوید",
        callback: () => this.softLogOut(),
      },
      {
        code: "Please wait...",
        message: "لطفا کمی دیگر مجددا برای ورود تلاش نمایید.",
      },
      {
        code: 1002,
        message: "کد وارد شده صحیح نیست.",
      },
      {
        code: 1004,
        message: "شماره وارد شده صحیح نیست",
      },
      {
        code: 2001,
        message: "لطفا پروفایلتان را تکمیل بفرمایید",
        callback: () => {
          Router.push("/panel/completeinfo");
        },
      },
      {
        code: 2005,
        message: "بار یافت نشد",
      },
      {
        code: 2006,
        message:
          "تلفن شما در سیستم ما به عنوان راننده ثبت شده است، و با این شماره قادر به ثبت بار هویت دار نیستید. ",
      },
      {
        code: 3000,
        message: "شما به این پنل دسترسی ندارید.",
        logOut: true,
      },
      {
        code: 3001,
        message:
          "خطا، شما دسترسی لازم برای این کار را ندارید. با پشتیبانی تماس بگیرید.",
      },
      {
        code: 3002,
        message: "حساب شما راننده نیست.",
        logOut: true,
      },
    ];

    let mustCheck = defaultMessages;

    if (changed) {
      mustCheck = Object.assign({}, defaultMessages, changed);
    }

    if (onlyThese.length) {
      mustCheck = mustCheck.filter((item) => onlyThese.includes(item.code));
    }

    if (dontCheck.length) {
      mustCheck = mustCheck.filter((item) => !dontCheck.includes(item.code));
    }

    let handleErr = false;

    mustCheck.forEach((item) => {
      if (item.code == message) {
        if (item.logOut) Store.commit("log_out");

        if (item.callback) item.callback();

        if (showMessage === true) {
          Store.commit("show_snackbar", {
            text: item.message,
          });

          handleErr = true;
          return true;
        } else {
          handleErr = item.message;
          return item.message;
        }
      }
    });

    return handleErr;
  },
  getRemainingPremiumDays() {
    let expireDate = Store.state.userPremiumSubscription?.get("expiresAt");
    if (!expireDate) return;

    expireDate = dayjs(expireDate);
    const now = dayjs();
    return expireDate.diff(now, "day");
  },
  /**
   * Format a number with adding comma
   *
   * @method formatNumber
   * @param num string or number, eg: 300000 | '300000'
   * @return {string} string of separated numbers by commas, eg: 30,000
   */
  formatNumber(number) {
    const num = Math.floor(number);
    const valid = typeof num == "number" ? !isNaN(num) && isFinite(num) : true;
    return valid ? addCommas(num) : "";
  },
  asciiNumbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  persianNums: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
  farsiChars: [
    "ا",
    "ب",
    "پ",
    "ت",
    "ث",
    "ج",
    "چ",
    "ح",
    "خ",
    "د",
    "ذ",
    "ر",
    "ز",
    "ژ",
    "س",
    "ش",
    "ص",
    "ض",
    "ط",
    "ظ",
    "ع",
    "غ",
    "ف",
    "ق",
    "ک",
    "گ",
    "ل",
    "م",
    "ن",
    "و",
    "ه",
    "ی",
  ],
  softLogOut() {
    localStorage.removeItem(`Parse/${Store.state.PARSE_APP_ID}/currentUser`);
    Parse.User._clearCache();
    Router.push({ name: "login" }).catch(() => {});
  },
};
